import {Component, Input, OnInit} from '@angular/core';
import {DialogComponent} from "../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../../auth/auth.service";
import {User} from "../../../user/user";
import {UserSubscription} from "../../../user/user-subscription";
import {DbResponse} from "../../../shared/interceptors/db-response";

@Component({
    selector: 'db-delete-account-dialog',
    templateUrl: './delete-account-dialog.component.html',
    styleUrls: ['./delete-account-dialog.component.scss'],
    standalone: false
})
export class DeleteAccountDialogComponent extends DialogComponent<null, Boolean> implements OnInit {
  @Input() user: User;
  @Input() currentSubscription: UserSubscription;
  @Input() currentWorkspaceId: number;
  public loading: boolean = false;
  public removeAccountForm = new FormGroup({
    password: new FormControl('', [Validators.required]),
  });

  constructor(private _dialogService: DialogService,
              private _authService: AuthService) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
  }

  public removeUserAccount() {
    if (this.removeAccountForm.invalid || this.loading) {
      return;
    }
    this.loading = true;
    this._authService.deleteUserAccount(this.currentWorkspaceId, this.removeAccountForm.getRawValue())
      .subscribe((response: DbResponse) => {
        if (response) {
          if (response.success) {
            this._authService.logout('account-deleted', this.user.id, this.currentSubscription);
          } else {
            this.loading = false;
            this.removeAccountForm.get('password').setErrors({server: response.message});
          }
        }
      });
  }

}
